import React from 'react';
import classNames from 'classnames';
import styles from '../marketplace-product-card.module.less';

/**
 * The base scaffolding for the product ctas.
 */
var BaseProductCtas = function BaseProductCtas(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      primaryCtaNode = _ref.primaryCtaNode,
      secondaryCtaNode = _ref.secondaryCtaNode,
      addToCompareNode = _ref.addToCompareNode;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.productCtas, className])
  }, addToCompareNode, /*#__PURE__*/React.createElement("div", {
    className: styles.productLinkAndSecondaryCta
  }, primaryCtaNode, secondaryCtaNode && /*#__PURE__*/React.createElement("div", {
    className: styles.secondaryCta
  }, secondaryCtaNode)));
};

if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable global-require, @typescript-eslint/no-var-requires */
  var PropTypes = require('prop-types');

  BaseProductCtas.propTypes = {
    className: PropTypes.string,
    primaryCtaNode: PropTypes.node,
    secondaryCtaNode: PropTypes.node
  };
  /* eslint-enable global-require, @typescript-eslint/no-var-requires */
}

export default BaseProductCtas;